/** @file viewportBindings: the viewport's key table (context `viewport`, chords by `event.code`). */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

/** One binding of the viewport context. */
const b = (id: string, keys: string): Binding => ({ id, keys, context: 'viewport' });

/**
 * F frame selection, 0 camera reset, Numpad 1 / 3 / 7 front, right, top and Numpad 5 the profile pitch (digits 1 2 3
 * stay the screen switch, design 19.8 D6), [ ] facing steps, Alt+R reset to rest, M mirror to twin, I isolate, G grid, J joints, Shift+J quads (Ctrl+V onto a part is the browser's paste event, `windowEvents`: Mod+V stays the timeline's),
 * arrows nudge (Shift x10). The tools (Q W E R T, X, Z) and Space, `,`, `.`, K, Shift+K are global bindings
 * (`shellBindings`, `transportBindings`), one chord one meaning. Handlers: `viewportCommands`; the new rows' labels:
 * `viewportBindingLabels`.
 */
export const viewportBindings: Binding[] = [
  b('viewport.frameSelection', 'KeyF'), b('viewport.camera.reset', 'Digit0'),
  b('viewport.view.front', 'Numpad1'), b('viewport.view.right', 'Numpad3'), b('viewport.view.top', 'Numpad7'),
  b('viewport.view.profilePitch', 'Numpad5'),
  b('viewport.facing.fewer', 'BracketLeft'), b('viewport.facing.more', 'BracketRight'),
  b('viewport.pose.rest', 'Alt+KeyR'),
  b('viewport.pose.mirror', 'KeyM'), b('viewport.isolate', 'KeyI'), b('viewport.grid.toggle', 'KeyG'), b('viewport.joints.toggle', 'KeyJ'),
  b('viewport.quads.toggle', 'Shift+KeyJ'),
  b('viewport.nudge.left', 'ArrowLeft'), b('viewport.nudge.right', 'ArrowRight'), b('viewport.nudge.up', 'ArrowUp'),
  b('viewport.nudge.down', 'ArrowDown'), b('viewport.nudge.left.big', 'Shift+ArrowLeft'),
  b('viewport.nudge.right.big', 'Shift+ArrowRight'), b('viewport.nudge.up.big', 'Shift+ArrowUp'),
  b('viewport.nudge.down.big', 'Shift+ArrowDown'),
];
